import { colors } from './colors';
import { buttons } from './buttons';
//////////////////////////////////////////////////

const theme = {
  colors,
  buttons,
  border: {},
  background: {
    page: colors.bgColor,
    loaderInner: colors.lime,
    loaderWrapper: 'rgba(0, 0, 0, 0.2)',
  },
  text: {
    error: colors.red,
    disabled: colors.grey,
    whiteColor: colors.white,
    secondary: colors.darkGrey,
    primary: colors.lightBlack,
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'Urbanist, serif',
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          fontSize: 13,
          minHeight: 30,
          maxHeight: 30,
          width: '100%',
          height: '30px',
          padding: '10px',
          outline: 'none',
          borderRadius: 4,
          maxWidth: '110px',
          backgroundColor: colors.white,
          transition: 'border-color 0.3s ease',
          border: `1px solid ${colors.middleGrey}`,
          boxShadow: `0 0 5px 0 ${colors.middleGrey}`,
        },
      },
    },
  },
};

export { theme };
